import React, {createContext, useContext} from 'react';

const defaultActions = {
  open: () => {},
  close: () => {},
};

export const MobileSearchActionsContext = createContext(defaultActions);

export function useMobileSearchActions() {
  return useContext(MobileSearchActionsContext);
}